import { useSearchParams, Link, useLocation } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const RestrictionsPage = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const isMobile = searchParams.get('isMobile') === '1' || searchParams.get('isMobile') === 'true';

  return (
    <div className="w-full bg-white min-h-screen flex flex-col">
      {!isMobile && <Header />}
      
      <div className="w-full bg-white inline-flex justify-center overflow-hidden">
        <div className="container pt-10 pb-20 px-4 md:px-0 flex flex-col justify-start items-start gap-[60px] overflow-hidden">
          <div className="w-full flex flex-col justify-start items-start gap-2.5">
            <div className="justify-center text-black text-[40px] font-bold leading-[60px]">利用制限について</div>
            <div className="h-[3px] w-full relative bg-[#e4e4e4]" />
            <div className="w-full justify-center text-black text-base font-normal leading-7">
              DONDONでは、すべてのお客様に安心してご利用いただくため、迷惑行為を固く禁止しております。<br/>
              該当する行為が確認された場合には、ご利用に制限を設けさせていただくことがあります。
            </div>
            <div className="flex flex-col justify-start items-start">
              <div className="w-full justify-center text-black text-base font-normal leading-7">詳しくは、以下のページをご確認ください。</div>
              <Link to={`/terms/guideline_listing${location.search}`} className="w-full justify-center text-[#00b8f9] text-base font-normal underline leading-7 hover:text-[#0099d6]">出品ガイドライン</Link>
              <Link to={`/terms/guideline_transaction${location.search}`} className="w-full justify-center text-[#00b8f9] text-base font-normal underline leading-7 hover:text-[#0099d6]">取引の流れ</Link>
            </div>
            <div className="w-full justify-center text-black text-base font-normal leading-7">
              利用制限にお心当たりがない場合や、制限の解除をご希望の場合は、お手数ですが事務局までご連絡ください。<br/>
              ※なお、お問い合わせをいただいても、状況によっては制限を解除できない場合がございます。あらかじめご了承ください。
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">出品制限</div>
            </div>
            <div className="w-full justify-center text-black text-base font-normal leading-7">
              出品機能および売上金の振込申請については、以下の行為が確認された場合に制限を設けております。<br/>
              また、取引成立後に迷惑行為が認められた場合には、購入機能にも制限が加えられることがあります。
            </div>
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">主な制限対象の行為</div>
              <div className="pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="justify-center text-black text-base font-normal leading-7">
                  ・出品ガイドラインに違反した出品<br/>
                  ・他のお客様のご迷惑となる行為<br/>
                  ・発送・到着期限の超過によるキャンセル<br/>
                  ・着払いによる発送
                </div>
              </div>
            </div>
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">キャンセル料に関する制限と解除</div>
              <div className="px-5 inline-flex justify-start items-center gap-2.5">
                <div className="justify-center text-black text-base font-normal leading-7">
                  キャンセル料のお支払いが完了すると、自動で制限が解除されます。<br/>
                  ※その他の理由による制限については、お問い合わせ内容に基づき、解除の可否を個別に判断いたします。
                </div>
              </div>
            </div>
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">違反金について</div>
              <div className="px-5 inline-flex justify-start items-center gap-2.5">
                <div className="justify-center">
                  <span className="text-black text-base font-normal leading-7">
                    悪質と判断される出品行為には、違反金（商品代金の50%）を請求させていただきます。<br/>
                    対象となる例：<br/>
                  </span>
                  <span className="text-black text-base font-normal leading-7">
                    ・偽造品と認定された商品の再出品<br/>
                    ・故意に偽造品を出品したと判断される場合
                  </span>
                </div>
              </div>
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">購入制限</div>
            </div>
            <div className="w-full justify-center text-black text-base font-normal leading-7">
              以下の対象行為があった場合、購入機能が制限されます。<br/>
              悪質な購入や利用については、全機能において制限を加えることがあります。
            </div>
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">主な対象行為</div>
              <div className="px-5 inline-flex justify-start items-center gap-2.5">
                <div className="justify-center text-black text-base font-normal leading-7">
                  ・発送期限・到着期限の超過によるキャンセル<br/>
                  ・不正利用（なりすましや不正な決済手段の使用など）
                </div>
              </div>
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">利用停止について</div>
            </div>
            <div className="w-full justify-center text-black text-base font-normal leading-7">
              事務局の判断のもと、悪質性の高い行為と判断した場合はDONDONの利用を全面的に停止します。
            </div>
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">主な対象行為</div>
              <div className="px-5 inline-flex justify-center items-center gap-2.5">
                <div className="justify-center text-black text-base font-normal leading-7">
                  ・マネーロンダリング<br/>
                  ・繰り返し行われる迷惑行為
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {!isMobile && <Footer />}
    </div>
  );
};

export default RestrictionsPage;